import React from 'react';
import { Drawer } from '@mui/material';
import ChatFeedbackInbox from './ChatFeedbackInbox';

/**
 * The admin's feedback inbox as a side panel over the order-entry page, so a
 * half-typed order underneath is never lost. onChanged fires after รับทราบ /
 * ขอชี้แจง / a reply so the KeyData banner can refetch its count.
 */
const ChatFeedbackDrawer = ({ open, onClose, onChanged }) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { width: 'min(640px, 100vw)', backgroundColor: '#f9fafb' } }}
  >
    <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-200 bg-white">
      <div className="font-bold text-gray-800">📋 Feedback การตอบแชทของฉัน</div>
      <button type="button" onClick={onClose} className="ml-auto text-gray-400 hover:text-gray-600 text-xl leading-none" aria-label="ปิด">✕</button>
    </div>
    {open && <ChatFeedbackInbox embedded onChanged={onChanged} />}
  </Drawer>
);

export default ChatFeedbackDrawer;
